/* eslint-disable import/prefer-default-export */

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useCreate: useCreateCirrSalary } = getCRUDHooks({
  entityName: 'cirrSalary',
  create: ({ userId, pathId, values }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .paths.id(pathId)
      .cirrSalary.create(values),
});

export { useCreateCirrSalary };
